import React, { useState, useEffect } from 'react'
import { Row, Col ,Modal,Form, Button as RBButton} from 'react-bootstrap'
import Card from '../../../components/Card'
import { getApiCall, postApiCall, postApiMediaCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import { toast } from 'react-toastify';
import { ROUTES ,NUMBERS_TYPES,NUBMERS_STATUS_LABEL, BULK_UPDATE_DID, BULK_UPDATE_OTHERS, ASSIGN_DID_VMN, ASSIGN_DID_TOLLFREE, SAMPLE_DATA_DID_UPDATE, SAMPLE_DATA_OTHERS_UPDATE} from '../../../utilities/constant';
import { EditIcon, DeleteIcon ,RefreshIcon} from '../../../components/setting/elements';
import { API_NUMBERS_LIST, API_NUMBER_DELETE, API_COUNTRY_CODES_LIST, API_DID_NUMBERS,API_NUMBER_STATUS,API_BULK_ASSIGN_DID,
    API_INDIVIDUAL_ASSIGN_DID,API_NUMBER_EDIT_BULK, API_VOICE_PLAN_LIST , API_COMPANY_LIST, API_DID_MAPPING, API_CALL_CENTRE_DEFAULT_CLI, API_INBOUND_ROUTING_REMOVE} from '../../../service/url';
import Loader  from '../../../components/partials/components/loader';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { Routes, useNavigate } from "react-router-dom";
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import "../../../assets/custom/css/tabs.css"
import exportData from '../../../utilities/export';
import downloadTemplate from '../../../utilities/downloadCsv'
//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
// images for 
import agentImg from '../../../assets/images/icons/agent.png';
import callgroupImg from '../../../assets/images/icons/callgroup.png';
import ivrImg from '../../../assets/images/icons/ivr.png';
import { TabView, TabPanel } from 'primereact/tabview';
import { FaEdit } from "react-icons/fa";
import {
    FiPlus,
    FiPhoneIncoming,
    FiPhoneOutgoing,
    FiRepeat,
    FiPhone,
    FiGlobe,
    FiMapPin,
    FiDollarSign,
    FiBriefcase,
    FiTag,
    FiClock,
    FiShare2,
} from 'react-icons/fi';


const numberTypeLabels = NUMBERS_TYPES.map(val => val['label']);
const categoryLabels = ['Free', 'Paid'];
const currencyLabels =['INR','USD'];

const formatNumberCreatedAt = (row) => {
    const raw = row?.createdAt || row?.created_at;
    if (!raw) return null;

    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return null;

    return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const getCountryIsoCode = (value) => {
    if (!value || !/^[A-Za-z]{2}$/.test(String(value).trim())) {
        return "";
    }

    return String(value).trim().toUpperCase();
};

const getCountryFlagUrl = (isoCode) => {
    const normalized = getCountryIsoCode(isoCode);
    if (!normalized) {
        return "";
    }

    return `https://flagcdn.com/w40/${normalized.toLowerCase()}.png`;
};

const resolveCountryMeta = (value, countries = []) => {
    if (value == null || value === "") {
        return null;
    }

    const normalized = String(value).trim();
    const normalizedUpper = normalized.toUpperCase();
    const normalizedCalling = normalized.replace(/^\+/, "");

    return countries.find((country) => {
        const isoCode = String(country?.code || "").trim().toUpperCase();
        const callingCode = String(country?.calling_code || "").trim().replace(/^\+/, "");

        return (
            isoCode === normalizedUpper ||
            String(country?.id) === normalized ||
            callingCode === normalizedCalling
        );
    }) || null;
};

const CountryFlag = ({ isoCode, label }) => {
    const flagUrl = getCountryFlagUrl(isoCode);
    if (!flagUrl) {
        return null;
    }

    return (
        <img
            src={flagUrl}
            alt={label ? `${label} flag` : "Country flag"}
            className="number-details-country-code__flag"
            width="24"
            height="18"
            loading="lazy"
        />
    );
};

const CountryCodeValue = ({ code, countries = [] }) => {
    if (!code) {
        return "-";
    }

    const country = resolveCountryMeta(code, countries);
    if (country) {
        const isoCode = getCountryIsoCode(country.code);
        const countryName = String(country.name || "").trim();

        return (
            <span className="number-details-country-code">
                <CountryFlag isoCode={isoCode} label={countryName || isoCode} />
                <span>{countryName ? `${isoCode} (${countryName})` : isoCode || code}</span>
            </span>
        );
    }

    const isoCode = getCountryIsoCode(code);
    if (isoCode) {
        return (
            <span className="number-details-country-code">
                <CountryFlag isoCode={isoCode} label={isoCode} />
                <span>{isoCode}</span>
            </span>
        );
    }

    return String(code).trim();
};

const NumberDetailBadge = ({ children, tone = "blue" }) => (
    <span className={`number-details-badge number-details-badge--${tone}`}>
        {children}
    </span>
);

const NumberDetailItem = ({ icon: Icon, iconTone = "blue", label, value, children }) => (
    <div className="number-details-item">
        <div className={`number-details-item__icon number-details-item__icon--${iconTone}`}>
            <Icon size={17} aria-hidden />
        </div>
        <div className="number-details-item__label">{label}</div>
        <div className="number-details-item__sep">:</div>
        <div className="number-details-item__value">{children ?? value ?? "-"}</div>
    </div>
);

const numberRoutingTypeCell = (rowData) => {
    const v = (rowData.number_routing_type || '').toString().toLowerCase().trim();
    if (!v) {
        return <span className="text-muted">—</span>;
    }
    const chipClass = "number-routing-chip";
    if (v === 'incoming') {
        return (
            <span className={`${chipClass} number-routing-chip--incoming`} title="Incoming">
                <FiPhoneIncoming size={15} aria-hidden />
                Incoming
            </span>
        );
    }
    if (v === 'outgoing') {
        return (
            <span className={`${chipClass} number-routing-chip--outgoing`} title="Outgoing">
                <FiPhoneOutgoing size={15} aria-hidden />
                Outgoing
            </span>
        );
    }
    if (v === 'both') {
        return (
            <span className={`${chipClass} number-routing-chip--both`} title="Both">
                <FiRepeat size={15} aria-hidden />
                Both
            </span>
        );
    }
    return (
        <span className={`${chipClass} number-routing-chip--default`} title={v}>
            {rowData.number_routing_type}
        </span>
    );
};


export default function NumberList() {
    const { checkAuth } = useAuth();
    const navigate = useNavigate();
    const [numbersList, setNumbersList] = useState([]);
    const [contentId, setContentId] = useState(undefined);
    const [filters, setFilters] = useState({
        actual_number: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        status: { value: null, matchMode: FilterMatchMode.CONTAINS },
        country_code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        state_code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        number_type: { value: null, matchMode: FilterMatchMode.EQUALS },
        category: { value: null, matchMode: FilterMatchMode.EQUALS },
        currency: { value: null, matchMode: FilterMatchMode.EQUALS },
        cost: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        operator: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    });
    const [numberType,setNumberType] = useState("All");
    const [enableDeleteModal, setEnableDeleteModal] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [deleteNumberId, setDeleteNumberId] = useState(undefined);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(null);
    const [countryCodeMap, setCountryCodeMap] = useState({});
    const [countryCodes, setCountryCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
    const [moduleOperations, setModuleOperations] = useState({});
    const [selectedNumbers, setSelectedNumber] = useState([]);
    const [isMultiDelete, setIsMultiDelete] = useState(false);
    const [showAssignDidButton, setShowAssignDidButton] = useState(false);
    const [showAllocateModal, setShowAllocateModal] = useState(false);
    const [selectedDID, setSelectedDID] = useState(null);
    const [allocateNumberId, setAllocateNumberId] = useState(null);
    const [didOptions, setDidOptions] = useState([]);
    const [allocateStatus, setAllocateStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [expiryDate, setExpiryDate] = useState(null);
    const [expiryDateError, setExpiryDateError] = useState("");
    const [showBulkAssignModal, setShowBulkAssignModal] = useState(false);
    const [csvFile, setCsvFile] = useState(undefined);
    const [selectedNumberType, setSelectedNumberType] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [bulkUpdateButton,setBulkUpdateButton] =useState(true);
    const [bulkUpdateModal,setBulkUpdateModal] =useState(false)
    const [updateNumberType, setUpdateNumberType] = useState('');
    const [userRole, setUserRole] = useState('');
    const [isCompanyUser, checkIsCompanyUser] = useState(false);
    const [isReseller, checkIsReseller] = useState(false);
    const [isCallcenterAdmin, checkIsCallcenterAdmin] = useState(false);
    const [searchValue, setSearchValue] = useState(null);
    const [originalNumbersList, setOriginalNumbersList] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [selectedPlanDetails, setSelectedPlanDetails] = useState([]);
    const [selectedPlanName, setSelectedPlanName] = useState('');
    const [loggedUserId, setLoggedUserId] = useState("")
    const [loggedUserType, setLoggedUserType] = useState("")
    const [loggedUser, setLoggedUser] = useState("")
        
    const [callCentreDefaultDidId, setCallCentreDefaultDidId] = useState(null)
    const [showNumberDetailsModal, setShowNumberDetailsModal] = useState(false);
    const [numberDetailsRow, setNumberDetailsRow] = useState(null);

    const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});

    const [showRemoveRoutingModal, setShowRemoveRoutingModal] = useState(false);
    const [removeRoutingLoading, setRemoveRoutingLoading] = useState(false);

      useEffect(() => {
        const user = getUser();
          if (user) {
            if (user?.acl_settings) {
              setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
            }
          }
      }, []);

      useEffect(() => {
        const onAclRefreshed = () => {
          const user = getUser();
          if (user?.acl_settings?.module_operations) {
            try {
              const parsed = typeof user.acl_settings.module_operations === "string"
                ? JSON.parse(user.acl_settings.module_operations)
                : user.acl_settings.module_operations;
              setModuleOperations(parsed);
              setModuleOperationsForReadPermissionCheck(parsed);
            } catch (e) {
              console.log("Failed to apply refreshed ACL", e);
            }
          }
        };
        window.addEventListener("acl-refreshed", onAclRefreshed);
        return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
      }, []);


    const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: `${numberType || "numbers"}-list`,
         data: numbersList,
         columns: [
            {
               header: numberType || "Number",
               accessor: (row) =>
                  row.actual_number || "-"
            },
            {
               header: "Country Code",
               accessor: (row) =>
                  row.country_code || "-"
            },
            {
               header: "State Code",
               accessor: (row) =>
                  row.state_code || "-"
            },

            ...(!(isReseller || isCompanyUser)
               ? [
                  {
                     header: "Cost",
                     accessor: (row) =>
                        row.cost || "-"
                  },
                  {
                     header: "Operator",
                     accessor: (row) =>
                        row.operator || "-"
                  },
                  {
                     header: "Category",
                     accessor: (row) =>
                        row.category || "-"
                  },
                  {
                     header: "Currency",
                     accessor: (row) =>
                        row.currency || "-"
                  }
               ]
               : []),

            {
               header: "Number Type",
               accessor: (row) =>
                  row.number_type || "-"
            },

            {
               header: "Status",
               accessor: (row) =>
                  row.status || "-"
            },

            ...(!(isReseller || isCompanyUser)
               ? [
                  {
                     header: "Routing Id",
                     accessor: (row) =>
                        row.routing_id || "-"
                  },
                  {
                     header: "Routing Type",
                     accessor: (row) =>
                        row.routing_type || "-"
                  },
                  {
                     header: "Routing Destination",
                     accessor: (row) =>
                        row.routing_destination || "-"
                  }
               ]
               : []),

            {
               header: "Plan Name",
               accessor: (row) =>
                  row.voice_plan_id?.plan_name || "-"
            },

            {
               header: "Allocated To",
               accessor: (row) =>
                  row.allocated_to?.name || "-"
            },

            {
               header: "Allocated Type",
               accessor: (row) =>
                  row.allocated_to?.type || "-"
            },

            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.createdAt || row.created_at)
                     .toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     })
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};
  
    const handleCheckboxToggle = (numberId) => {
      const isSelected = selectedNumbers.includes(numberId);
      setSelectedNumber(isSelected
          ? selectedNumbers.filter(id => id !== numberId)
          : [...selectedNumbers, numberId]);
    };
  
    const handleMultiDelete = () => {
          setIsMultiDelete(true);
          setEnableDeleteModal(true);
    };

    const handleRemoveInboundRouting = () => {
        if (!selectedNumbers.length) return;
        setShowRemoveRoutingModal(true);
    };

    const confirmRemoveInboundRouting = () => {
        if (!selectedNumbers.length) {
            setShowRemoveRoutingModal(false);
            return;
        }
        setRemoveRoutingLoading(true);
        postApiCall(API_INBOUND_ROUTING_REMOVE, { numberIds: selectedNumbers })
            .then((resp) => {
                toast.success(resp?.message || "Inbound routing removed");
                setShowRemoveRoutingModal(false);
                setSelectedNumber([]);
                setLoading(true);
                getApiCall(API_NUMBERS_LIST)
                    .then(onNumberListSuccess)
                    .catch(onError)
                    .finally(() => setLoading(false));
            })
            .catch((err) => {
                toast.error(`Unable to remove inbound routing: ${err}`);
            })
            .finally(() => setRemoveRoutingLoading(false));
    };

    const handleAllocateClick = (id) => {
        checkAuth(setToastProps, setShowToast)
        let index = numbersList.map(i => i.id).indexOf(id)
        setAllocateNumberId(id);
        setSelectedDID(null);
        setShowAllocateModal(true);
        setSelectedNumberType(numbersList[index].number_type);
    };

    // useEffect(() => {

    //     if (toastProps) {
    //         setShowToast(true);
    //     }

    // }, [toastProps]);

    useEffect(() => {
        setLoading(true);
        getApiCall(API_NUMBERS_LIST)
            .then(onNumberListSuccess)
            .catch(onError)
            .finally(() => setLoading(false));

        getApiCall(API_COUNTRY_CODES_LIST)
            .then(resp => {
                const list = Array.isArray(resp) ? resp : [];
                const ccList = {};

                list.forEach((val) => {
                    ccList[val.id] = val.calling_code;
                });

                setCountryCodes(list);
                setCountryCodeMap(ccList);
            })
            .catch(onError);

            getApiCall(API_DID_NUMBERS)
            .then(resp => {
                const didOptions = resp.map(did => ({
                    label: did.actual_number.toString(),
                    value: did.id.toString()
                }));

                setDidOptions(didOptions);
            })
            .catch(onError);
        
  
        getApiCall(API_NUMBER_STATUS)
            .then(resp => {
               const sList= resp.map(item =>({
                status: item.status,
                status_code: item.status_code,
                }))
                
                setAllocateStatus(sList)
            })
            .catch(onError)

    }, []);

    useEffect(() => {
        const user = getUser();
          if (user) {
            setUserRole(user.role);
            setLoggedUserId(user.id)
            setLoggedUser(user)
            if (user.role === USER_ROLES.SUPERADMIN) {
              setLoggedUserType('Superadmin')  
              checkIsSuperAdmin(true);
            }
            if (user.role === USER_ROLES.RESELLER) {
                setLoggedUserType('Reseller')  
                checkIsReseller(true);
              }
            if (user.role === USER_ROLES.COMPANY_ADMIN) {
                setLoggedUserType('Company')  
                checkIsCompanyUser(true);
            }
            if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
                setLoggedUserType('Call Center')  
                checkIsCallcenterAdmin(true);
            }
            if (user?.acl_settings) {
                setModuleOperations(JSON.parse(user.acl_settings.module_operations));
              }
          }
      }, []);


        useEffect(() => {
          const resp = getUser();

            if (resp) {
              setContentId(resp.id);
            }
        }, []);

    useEffect(() => {
        fetchCallCentreDefaultCli();
    }, [userRole]);

    function onNumberListSuccess(resp) {
        const updatedList = resp.map((val, idx) => {
            val['key'] = idx + 1;
            // val['createdAt'] = new Date(val['createdAt']).toGMTString();
            return val;
        });
        setNumbersList(updatedList);
        setOriginalNumbersList(updatedList);
    }

    const fetchCallCentreDefaultCli = () => {
        if (userRole !== USER_ROLES.CALL_CENTRE_ADMIN) return;
        getApiCall(API_CALL_CENTRE_DEFAULT_CLI)
            .then((resp) => {
                setCallCentreDefaultDidId(resp?.numberId ? Number(resp.numberId) : null);
            })
            .catch(onError);
    };

      useEffect(() => {
        if(searchValue){
          setNumbersList(
             originalNumbersList.filter((number) => number.actual_number.toString().includes(searchValue.trim()))
          );
        }
        else {
            setNumbersList(originalNumbersList);
        }
      }, [searchValue]);

    function handleDeleteNumber(id) {
        checkAuth(setToastProps, setShowToast)
        setIsMultiDelete(false);
        setEnableDeleteModal(true);
        setDeleteNumberId(id);
    }

    const handleSelectAll = () => {
        if (selectedNumbers.length === numbersList.length) {
            setSelectedNumber([]);
        } else {
            const allNumberIds = numbersList.map(number => number.id);
            setSelectedNumber(allNumberIds);
        }
      };

      useEffect( () => {
        if (confirmDelete) {
            if (isMultiDelete) {
                postApiCall(API_NUMBER_DELETE, { numberIds: selectedNumbers })
                    .then(onDeleteSuccess)
                    .catch(onDeleteFail);
            } else {
                postApiCall(API_NUMBER_DELETE, { numberIds: [deleteNumberId] })
                    .then(onDeleteSuccess)
                    .catch(onDeleteFail);
            }
        }
        }, [confirmDelete]);
    

    function onDeleteSuccess(resp) {
        // setToastProps({ type: 'success', message: 'Number deleted successfully' });
            toast.success(resp.message || "Number deleted successfully");
        let updatedList;
        if (isMultiDelete) {
            updatedList = numbersList.filter(val => !selectedNumbers.includes(val.id)).map((val, key) => {
                val['key'] = key + 1;
                return val;
            });
            setSelectedNumber([]);
        } else {
            updatedList = numbersList.filter(val => val.id !== deleteNumberId).map((val, key) => {
                val['key'] = key + 1;
                return val;
            });
        }
        setNumbersList(updatedList);
        setEnableDeleteModal(false);
        setDeleteNumberId(undefined);
        setConfirmDelete(false); 
        setLoading(true);
        getApiCall(API_NUMBERS_LIST)
            .then(onNumberListSuccess)
            .catch(onError)
            .finally(() => setLoading(false));
    }

    function onDeleteFail(err) {
        if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
            errorCheck(err, navigate, setToastProps, setShowToast)
         } else {
        // setToastProps({ type: 'danger', message: `Unable to delete Number: ${err}` });
            toast.error(`Unable to delete Number: ${err}`);
         }
         setConfirmDelete(false);
    }

    const RenderActionComponent = ({id,number_type,routingType}) => {
        const numberEditRoute = ROUTES.NUMBERS.EDIT.replace(':id', id);
        const editDestinationRoute = ROUTES.IVR.UPDATE_INBOUND_CALLS.replace(':cid', id);
        return (
            <div className="flex align-items-center list-user-action">
                {(isSuperAdmin) && (
                    <EditIcon linkTo={`/${numberEditRoute}`} />
                )}
                {' '}
                {!(selectedNumbers.length > 0) && (isSuperAdmin) && (
                  <DeleteIcon handleCallback={() => handleDeleteNumber(id)} />
                )}
                {' '}
                {/* {(number_type === 'VMN' || number_type === 'TOLL FREE') && (
                <Button className="btn btn-sm btn-icon btn-primary" title='Allocate' onClick={() => handleAllocateClick(id)}>
                    Allocate
                </Button>
                )} */}
                {((routingType === 'IVR' || routingType ==='AGENT' || routingType ==='QUEUE') && isCallcenterAdmin ) && (
                <Button className="btn btn-sm btn-icon btn-primary" title='Edit Destination' onClick={() =>  navigate(`/${editDestinationRoute}`)} style={{ width: '36px', height: '36px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FaEdit />
                </Button>
                )}
            </div>
        );

    }


    const handleBulkAssignClick = (type) => {
        setShowBulkAssignModal(true);

    };

    const handleSetCallCentreDefault = (numberId, removeDefault = false) => {
        const payload = removeDefault ? { removeDefault: true } : { numberId };
        postApiCall(API_CALL_CENTRE_DEFAULT_CLI, payload)
            .then((resp) => {
                toast.success(resp?.message || (removeDefault ? "Default CLI removed" : "Default CLI updated"));
                setCallCentreDefaultDidId(removeDefault ? null : Number(numberId));
                setSelectedNumber([]);
            })
            .catch((err) => {
                toast.error(`Unable to update default CLI: ${err}`);
            });
    };
    
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setCsvFile(file);
    };
    

    async function handleBulkAssign() {

        const formData = new FormData();
         formData.append('pool', 'pool');
         formData.append('phone_numbers', csvFile);
         formData.append("type", numberType); 
  
         postApiMediaCall(API_BULK_ASSIGN_DID, formData)
             .then(resp => {
                // setToastProps({ type: 'success', message: 'Bulk DID assigned successfully' });
                        toast.success("Bulk DID assigned successfully");
                            setShowBulkAssignModal(false);
                            getApiCall(API_NUMBERS_LIST)
                           .then(onNumberListSuccess)
                           .catch(onError);
                            
                 
             })
             .catch(err => {
                // setToastProps({ type: 'danger', message: `Failed to assign bulk DID: ${err}` });
                        toast.error(`Failed to assign bulk DID: ${err}`);
                            console.log("error",err);
             })
 
            }
    

    const handleAllocate = () => {
        const payload = {
            DID: selectedDID.label,
            DID_id: selectedDID.value,
            expiryDate: expiryDate,
            numberType:selectedNumberType,
            status: selectedStatus.toString(),
             id: allocateNumberId,
           
           };

        postApiCall(API_INDIVIDUAL_ASSIGN_DID,payload)
            .then(() => {
                // setToastProps({ type: 'success', message: 'Number allocated successfully' });
           toast.success("Number allocated successfully");
                setShowAllocateModal(false);
                setSelectedDID(null);
                setExpiryDate();
                getApiCall(API_NUMBERS_LIST)
                .then(onNumberListSuccess)
                .catch(onError);
              
            })
            .catch(err => {
                // setToastProps({ type: 'danger', message: `Allocation failed: ${err}` });
                        toast.error(`Allocation failed: ${err}`);
            });
    };

    const handleBulkUpdate =() =>{
        if (!updateNumberType) {
            toast.error("Number Type is required");
            return;
        }
        const formData = new FormData();
         formData.append('phone_numbers', csvFile);
         formData.append("numberType", updateNumberType);

         postApiMediaCall(API_NUMBER_EDIT_BULK, formData)
         .then(resp => {
            // setToastProps({ type: 'success', message: 'Bulk Update Successfull.' });
                    toast.success("Bulk Update Successfull.");
                        setShowBulkAssignModal(false);
                        getApiCall(API_NUMBERS_LIST)
                        .then(onNumberListSuccess)
                        .catch(onError);
             
         })
         .catch(err => {
            // setToastProps({ type: 'danger', message: `Failed to assign bulk update: ${err}` });
            toast.error(`Failed to assign bulk update: ${err}`);
                        console.log("error",err);
         })
    }
            
    const dropdownItemTemplate = (option) => {
        return <span>{option}</span>;
    }

    const numberTypeFilterTemplate = options => {
        return <Dropdown value={options.value} options={numberTypeLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
     }

     const categoryFilterTemplate = options => {
        return <Dropdown value={options.value} options={categoryLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select Category" className="p-column-filter" showClear />;
     }
     const currencyFilterTemplate = options => {
        return <Dropdown value={options.value} options={currencyLabels} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select Currency" className="p-column-filter" showClear />;
     }
    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={NUBMERS_STATUS_LABEL} onChange={(e) => options.filterCallback(e.value)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
    }

    function onError(err) {
        if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
            errorCheck(err, navigate, setToastProps, setShowToast)
         } else {
           console.log(err)
         }
     }
    
    const handleCreateButtonClick = () => {
        navigate(`/${ROUTES.NUMBERS.CREATE}`)
     } 

     const handleNumberTypeFilter = (type) => {
        setNumberType(type);
        setShowAssignDidButton(type === 'VMN' || type === 'TOLL FREE');
    
        setFilters((prevFilters) => {
            if (type === 'All') {
                const { number_type, ...remainingFilters } = prevFilters;
                return remainingFilters;
            }
            return {
                ...prevFilters,
                number_type: { value: type, matchMode: FilterMatchMode.EQUALS },
            };
        });
    
        if (type === '') {
            setBulkUpdateButton(false);
        } else {
            setBulkUpdateButton(true);
        }
    };
    

    const resetAllocateModalState = () => {
        setSelectedDID(null);
        setSelectedStatus(null);
        setExpiryDate(null);
        setExpiryDateError("");
        setUpdateNumberType(null);
        
    };



    const handleExpiryDateChange = (e) => {
        const date = e.target.value;
        const today = new Date();
        const selectedDate = new Date(date);

        if (selectedDate <= today) {
            setExpiryDateError("Expiry date must be in the future");
        } else {
            setExpiryDateError("");
        }

        setExpiryDate(date);
    };

  
     const rowClassName = (data) => {
        return {
            'highlighted-row': selectedNumbers.includes(data.id),
            'default-cli-row': Number(callCentreDefaultDidId) === Number(data.id),
          };
    }

    const openNumberDetails = (rowData) => {
        setNumberDetailsRow(rowData);
        setShowNumberDetailsModal(true);
    };

    const viewNumberDetailsTemplate = (rowData) => (
        <RBButton
            variant="primary"
            className="numbers-list-view-btn w-100"
            style={{ height: "34px", paddingTop: "2px", paddingBottom: "2px", lineHeight: "1.25" }}
            onClick={() => openNumberDetails(rowData)}
        >
            View
        </RBButton>
    );

    const renderRoutingTypeBody = (rowData, iconSize = 30) => {
        if (!rowData.routing_type) {
            return "-";
        }

        if (rowData.routing_type === "AGENT") {
            return <img src={agentImg} alt="Agent" style={{ width: `${iconSize}px`, height: `${iconSize}px` }} title="Agent" />;
        }

        if (rowData.routing_type === "IVR") {
            return <img src={ivrImg} alt="IVR" style={{ width: `${iconSize}px`, height: `${iconSize}px` }} title="IVR" />;
        }

        if (rowData.routing_type === "QUEUE" || rowData.routing_type === "CALL GROUP") {
            return <img src={callgroupImg} alt="Call Group" style={{ width: `${iconSize}px`, height: `${iconSize}px` }} title="Call Group" />;
        }

        return rowData.routing_type;
    };

    const renderNumberStatusBody = (rowData) => {
        if (isSuperAdmin) {
            return rowData.allocated_to === null ? rowData.status : "Allocated";
        }

        if (isReseller) {
            if (
                rowData.allocated_to &&
                rowData.allocated_to.id === loggedUserId &&
                rowData.allocated_to.type === loggedUserType
            ) {
                return rowData.status;
            }

            return "Allocated";
        }

        if (isCompanyUser) {
            if (
                rowData.allocated_to &&
                rowData.allocated_to.id === loggedUser.company_id &&
                rowData.allocated_to.type === loggedUserType
            ) {
                return rowData.status;
            }

            return "Allocated";
        }

        if (isCallcenterAdmin) {
            if (
                rowData.allocated_to &&
                rowData.allocated_to.id === loggedUser.callcenter_id &&
                rowData.allocated_to.type === loggedUserType
            ) {
                return rowData.status;
            }

            return "Allocated";
        }

        return rowData.status || "-";
    };

    const dropdownOptionStatus = allocateStatus.map(item =>({label:item.status,value:item.status_code}))

    
    const handleBulkUpdateButtonClick = (type) => {
        setBulkUpdateModal(true);
    };


    const getColumnsAndFilename = (numberType) => {
        let columns;
        let filename;
        let sample_data;
    
        if (numberType === 'DID') {
            columns = BULK_UPDATE_DID;
            filename = `${numberType}-Update.csv`;
            sample_data = SAMPLE_DATA_DID_UPDATE;
        } else if (numberType === 'VMN') {
            columns = BULK_UPDATE_OTHERS;
            filename = `${numberType}-Update.csv`;
            sample_data = SAMPLE_DATA_OTHERS_UPDATE;
        } else {
            columns = BULK_UPDATE_OTHERS;
            filename = `${numberType}-Update.csv`;
            sample_data = SAMPLE_DATA_OTHERS_UPDATE;
        }
    
        return { columns, filename, sample_data };
    };

    const getColumnsAndFilenameForAssignDID = (numberType) => {
        let columns;
        let filename;
    
        if (numberType === 'VMN') {
            columns = ASSIGN_DID_VMN;
            filename = `${numberType}-AssignDID.csv`;
        } else {
            columns = ASSIGN_DID_TOLLFREE;
            filename = `${numberType}-AssignDID.csv`;
        }
    
        return { columns, filename };
    };


    useEffect(() => {
        if (!originalNumbersList.length) return;

        const typeMap = ["DID", "VMN", "TOLL FREE"];
        const selectedType = typeMap[activeIndex];

        if (!selectedType) {
            setNumbersList(originalNumbersList);
            return;
        }

        const filtered = originalNumbersList.filter(
            (item) => item.number_type === selectedType
        );

        setNumbersList(filtered);
    }, [activeIndex, originalNumbersList]);

    const canRead = hasPermission(
         moduleOperationsForReadPermissionCheck,
         "Numbers",
         "read",
       );
     
       if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
         return (
           <div
             className="text-center p-4"
             style={{
               marginTop: "50px",
               marginBottom: "50px",
               fontSize: "16px",
             }}
           >
             No read permission found in assigned ACL
           </div>
         );
       }

    if (loading) {
        return <Loader />
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title">Numbers List</h4>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                {[USER_ROLES.CALL_CENTRE_ADMIN, USER_ROLES.SUPERADMIN, USER_ROLES.SUB_SUPERADMIN].includes(userRole) && (
                                    <>
                                        {/* Icons before refresh */}
                                        <img src={agentImg} alt="Agent" title="Agent" style={{ width: "30px", height: "30px" }} /> - Agent
                                        <img src={ivrImg} alt="IVR" title="IVR" style={{ width: "30px", height: "30px" }} /> - IVR
                                        <img src={callgroupImg} alt="Call Group" title="Call Group" style={{ width: "30px", height: "30px" }} /> - Call Group         
                                    </>
                                )}
                                

                                {/* Buttons */}
                                <button className="btn btn-primary me-2" onClick={() => {
                                    setActiveIndex(0);
                                    setNumberType("DID");
                                    setShowAssignDidButton(false);
                                    // setBulkUpdateButton(false);
                                    getApiCall(API_NUMBERS_LIST)
                                        .then(onNumberListSuccess)
                                        .catch(onError);
                                }}>Refresh</button>

                                {(isSuperAdmin) && (
                                <button className="btn btn-primary" onClick={handleCreateButtonClick}>
                                    <FiPlus className="me-1" />
                                    Create Number
                                </button>
                                )}

                                {userRole === USER_ROLES.CALL_CENTRE_ADMIN && (
                                <button 
                                    className="btn btn-primary m-2" 
                                    onClick={() => navigate(`/${ROUTES.IVR.INBOUND_CALLS.replace(":cid", contentId)}`)}>
                                    Inbound Calling
                                </button>
                                )}
                            </div>
                            </Card.Header>

                            <Card.Body className="px-0">
                                <div className="custom-tab-container">
                                    <Row className="d-flex align-items-center">
                                    
                                        <Col className="d-flex justify-content-end">
                                            {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.delete)) && (
                                                <Button
                                                    label="Delete Selected"
                                                    onClick={handleMultiDelete}
                                                    className="p-button-danger"
                                                    style={{ fontSize: "14px", padding: "0px 8px", marginLeft: "10px" }}
                                                    disabled={selectedNumbers.length === 0}
                                                />
                                            )}
                                            {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.edit)) && (
                                                <Button
                                                    label="Remove Inbound Routing"
                                                    onClick={handleRemoveInboundRouting}
                                                    className="p-button-warning"
                                                    style={{ fontSize: "14px", padding: "0px 8px", marginLeft: "10px" }}
                                                    disabled={selectedNumbers.length === 0}
                                                />
                                            )}
                                            {isCallcenterAdmin && (
                                                <Button
                                                    label={
                                                        selectedNumbers.length === 1 &&
                                                        Number(callCentreDefaultDidId) === Number(selectedNumbers[0])
                                                            ? "Remove Default"
                                                            : "Mark As Default"
                                                    }
                                                    onClick={() =>
                                                        handleSetCallCentreDefault(
                                                            selectedNumbers[0],
                                                            selectedNumbers.length === 1 &&
                                                              Number(callCentreDefaultDidId) === Number(selectedNumbers[0])
                                                        )
                                                    }
                                                    className="p-button-primary"
                                                    style={{ fontSize: "14px", padding: "0px 8px", marginLeft: "10px" }}
                                                    disabled={selectedNumbers.length !== 1}
                                                />
                                            )}
                                            {numbersList.length > 0 &&
                                             <Button 
                                             label="Export Data"
                                             icon="pi pi-file-export"
                                             onClick={handleExport} 
                                             className="p-button-active" 
                                             style={{ fontSize: "14px", padding: "0px 8px", marginLeft: "10px" }}
                                             disabled={buttonDisable} 
                                             >
                                             &nbsp;
                                             {buttonDisable && (
                                                 <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                             )}
                                             </Button>
                                            }
                                           

                                            <Form.Group style={{height: "45px"}}>
                                                <Form.Control
                                                    style={{marginLeft: "10px",marginRight: "10px", margintop: "5px" ,border: "1px solid #ced4da", fontSize: "14px", height: "44px", width: "200px"}}
                                                    placeholder = 'Search by Number...'
                                                    type="number"
                                                    maxLength={100}
                                                    value={searchValue}
                                                    onChange={(e) => setSearchValue(e.target.value)}
                                                    required
                                                />
                                            </Form.Group>

                                            {/* {(showAssignDidButton) && (
                                                <button className="btn btn-success btn-sm button-spacing" onClick={() => handleBulkAssignClick(numberType)}>Assign User</button>
                                            )} */}
                                            {(bulkUpdateButton) && (
                                                <button className="btn btn-success btn-sm button-spacing" onClick={() => handleBulkUpdateButtonClick(numberType)}>Bulk Update</button>
                                            )}

                                        </Col>
                                       

                                    </Row>
                                    <TabView 
                                        activeIndex={activeIndex} 
                                        onTabChange={(e) => {
                                            setActiveIndex(e.index)
                                            setNumberType(["DID", "VMN", "TOLL FREE"][e.index])
                                            setShowAssignDidButton(
                                                ["VMN", "TOLL FREE"].includes(["DID", "VMN", "TOLL FREE"][e.index])
                                            );
                                            setBulkUpdateButton(true);
                                        }}>
                                        {["DID", "VMN", "TOLL FREE"].map((tab, index) => (
                                        <TabPanel
                                            key={index}
                                            header={
                                            <span
                                            style={{
                                                display: "inline-block",
                                                borderRadius: "5px",
                                                fontWeight: activeIndex === index ? "bold" : "normal",
                                                border: 'none'
                                              }}
                                            >
                                                {tab}
                                            </span>
                                            }
                                        >
                                            <div className="scroll-container numbers-list-datatable-wrap">
                                                <DataTable value={numbersList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                                                    <Column 
                                                        header={<Checkbox 
                                                        checked={selectedNumbers.length === numbersList.length && numbersList.length > 0} 
                                                        onChange={handleSelectAll} 
                                                        />} 
                                                        headerStyle={{ width: '3rem' }} 
                                                        body={(rowData) =>
                                                            (
                                                            
                                                            <Checkbox 
                                                            checked={selectedNumbers.includes(rowData.id)} 
                                                            onChange={() => handleCheckboxToggle(rowData.id)} 
                                                            />
                            
                                                            )} 
                                                    />
                                                    <Column field="actual_number" filterField="actual_number" header={numberType} filter filterPlaceholder="Search by Number" body={(rowData) => (
                                                        <div className="number-cell">
                                                            <span>{rowData.actual_number || '-'}</span>
                                                            {Number(callCentreDefaultDidId) === Number(rowData.id) && (
                                                                <span className="default-cli-badge">Default</span>
                                                            )}
                                                        </div>
                                                    )}></Column>
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="routing_type" filterField="routing_type" header="Routing Type" filter filterPlaceholder="Search by Routing Type" body={(rowData) => renderRoutingTypeBody(rowData)}></Column>
                                                    )}
                                                    {!(isReseller || isCompanyUser) && (
                                                        <Column field="routing_destination" filterField="routing_destination" header="Routing Destination" filter filterPlaceholder="Search by Routing" body={(rowData) => rowData.routing_destination || '-'}></Column>
                                                    )}
                                                    <Column field="number_type" filterField="number_type" header="Number Type" filter filterPlaceholder="Search by Number Type" filterElement={numberTypeFilterTemplate} body={(rowData) => rowData.number_type || '-'}></Column>
                                                    <Column
                                                        field="status"
                                                        header="Status"
                                                        filterElement={statusFilterTemplate}
                                                        filter
                                                        body={renderNumberStatusBody}
                                                    />
                                                    <Column
                                                        field="voice_plan_id.plan_name"
                                                        header="Plan Name"
                                                        body={(rowData) => {
                                                            const planName = rowData?.voice_plan_id?.plan_name;
                                                            return planName ? (
                                                            <button
                                                                className="plan-name-chip"
                                                                onClick={() => {
                                                                setSelectedPlanDetails(rowData.voice_plan_id.plans || []);
                                                                setSelectedPlanName(planName);
                                                                setShowPlanModal(true);
                                                                }}
                                                            >
                                                                {planName}
                                                            </button>
                                                            ) : null;
                                                        }}
                                                    />
                                                   
                                                    {/* {!(isReseller || isCompanyUser) && (
                                                        <Column field="routing_id" filterField="routing_id" header="Routing Id" filter filterPlaceholder="Search by Routing Id" body={(rowData) => rowData.routing_id || '-'}></Column>
                                                    )} */}
                                                    <Column
                                                        field="number_routing_type"
                                                        header="Number routing"
                                                        body={numberRoutingTypeCell}
                                                    />
                                                     <Column
                                                        field="allocated_to.name"
                                                        header="Allocated To"
                                                    ></Column>
                                                    <Column
                                                        field="allocated_to.type"
                                                        header="Allocated Type"
                                                    ></Column>
                                                    <Column field="createdAt" header="Created Date"
                                                     body={(rowData) =>
                                                        new Date(rowData.createdAt).toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                        })
                                                    }
                                                    ></Column>
                                                    <Column header="Details" body={viewNumberDetailsTemplate} />
                                                    {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.edit || moduleOperations?.[MODULE_ACL.NUMBERS]?.delete)) && (
                                                    <Column header="Action" body={(rowData)=><RenderActionComponent id={rowData.id} number_type={rowData.number_type} routingType={rowData.routing_type} />}></Column>
                                                    )}
                                                </DataTable>
                                            </div>
                                        </TabPanel>
                                        ))}
                                    </TabView>

                                   
                                    {(!["DID", "VMN", "TOLL FREE"].includes(["DID", "VMN", "TOLL FREE"][activeIndex])) && (
                                        <div className="scroll-container numbers-list-datatable-wrap">
                                            <DataTable value={numbersList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                                                <Column 
                                                    header={<Checkbox 
                                                    checked={selectedNumbers.length === numbersList.length && numbersList.length > 0} 
                                                    onChange={handleSelectAll} 
                                                    />} 
                                                    headerStyle={{ width: '3rem' }} 
                                                    body={(rowData) => (
                                                        <Checkbox 
                                                        checked={selectedNumbers.includes(rowData.id)} 
                                                        onChange={() => handleCheckboxToggle(rowData.id)} 
                                                        />
                                                        )} 
                                                />
                                                <Column field="actual_number" filterField="actual_number" header={numberType} filter filterPlaceholder="Search by Number" body={(rowData) => (
                                                    <div className="number-cell">
                                                        <span>{rowData.actual_number || '-'}</span>
                                                        {Number(callCentreDefaultDidId) === Number(rowData.id) && (
                                                            <span className="default-cli-badge">Default</span>
                                                        )}
                                                    </div>
                                                )}></Column>
                                                <Column field="number_type" filterField="number_type" header="Number Type" filter filterPlaceholder="Search by Number Type" filterElement={numberTypeFilterTemplate} body={(rowData) => rowData.number_type || '-'}></Column>
                                                <Column field="status" header="Status" filterElement={statusFilterTemplate} filter body={(rowData) => rowData.status || '-'}></Column>
                                                <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="routing_id" filterField="routing_id" header="Routing Id" filter filterPlaceholder="Search by Routing Id" body={(rowData) => rowData.routing_id || '-'}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="routing_type" filterField="routing_type" header="Routing Type" filter filterPlaceholder="Search by Routing Type" body={(rowData) => renderRoutingTypeBody(rowData, 23)}></Column>
                                                )}
                                                {!(isReseller || isCompanyUser) && (
                                                    <Column field="routing_destination" filterField="routing_destination" header="Routing Destination" filter filterPlaceholder="Search by Routing" body={(rowData) => rowData.routing_destination || '-'}></Column>
                                                )}
                                                <Column
                                                    field="number_routing_type"
                                                    header="Number routing"
                                                    body={numberRoutingTypeCell}
                                                />
                                                <Column header="Details" body={viewNumberDetailsTemplate} />
                                                {((isSuperAdmin || moduleOperations?.[MODULE_ACL.NUMBERS]?.edit || moduleOperations?.[MODULE_ACL.NUMBERS]?.delete)) && (
                                                <Column header="Action" body={(rowData)=><RenderActionComponent id={rowData.id} number_type={rowData.number_type} routingType = {rowData.routing_type} />}></Column>
                                                )}
                                            </DataTable>
                                        </div>
                                    )}
                                        
                                   
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            <Modal
                show={showNumberDetailsModal}
                onHide={() => {
                    setShowNumberDetailsModal(false);
                    setNumberDetailsRow(null);
                }}
                size="lg"
                centered
                dialogClassName="number-details-modal__dialog"
                contentClassName="number-details-modal__content"
            >
                <Modal.Header closeButton className="number-details-modal__header">
                    <div className="number-details-modal__header-main">
                        <div className="number-details-modal__header-icon">
                            <FiPhone size={18} aria-hidden />
                        </div>
                        <Modal.Title className="number-details-modal__title">Number Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body className="number-details-modal__body">
                    <Row className="g-4 align-items-stretch">
                        <Col lg={7}>
                            <div className="number-details-panel">
                                <NumberDetailItem
                                    icon={FiPhone}
                                    iconTone="blue"
                                    label="Number"
                                    value={numberDetailsRow?.actual_number}
                                >
                                    <strong>{numberDetailsRow?.actual_number || "-"}</strong>
                                </NumberDetailItem>
                                <NumberDetailItem
                                    icon={FiGlobe}
                                    iconTone="green"
                                    label="Country Code"
                                >
                                    <CountryCodeValue
                                        code={numberDetailsRow?.country_code}
                                        countries={countryCodes}
                                    />
                                </NumberDetailItem>
                                <NumberDetailItem
                                    icon={FiMapPin}
                                    iconTone="purple"
                                    label="State Code"
                                    value={numberDetailsRow?.state_code}
                                />
                                {!(isReseller || isCompanyUser) && (
                                    <NumberDetailItem
                                        icon={FiDollarSign}
                                        iconTone="amber"
                                        label="Cost"
                                        value={numberDetailsRow?.cost ?? "-"}
                                    />
                                )}
                                {!(isReseller || isCompanyUser) && (
                                    <NumberDetailItem
                                        icon={FiBriefcase}
                                        iconTone="blue"
                                        label="Operator"
                                        value={numberDetailsRow?.operator}
                                    />
                                )}
                                {!(isReseller || isCompanyUser) && (
                                    <NumberDetailItem
                                        icon={FiTag}
                                        iconTone="rose"
                                        label="Category"
                                    >
                                        {numberDetailsRow?.category ? (
                                            <NumberDetailBadge
                                                tone={
                                                    String(numberDetailsRow.category).toLowerCase() === "free"
                                                        ? "green"
                                                        : "amber"
                                                }
                                            >
                                                {numberDetailsRow.category}
                                            </NumberDetailBadge>
                                        ) : (
                                            "-"
                                        )}
                                    </NumberDetailItem>
                                )}
                                {!(isReseller || isCompanyUser) && (
                                    <NumberDetailItem
                                        icon={FiDollarSign}
                                        iconTone="green"
                                        label="Currency"
                                        value={numberDetailsRow?.currency}
                                    />
                                )}
                                <NumberDetailItem icon={FiShare2} iconTone="purple" label="Trunk">
                                    {numberDetailsRow?.trunkId?.name ? (
                                        <NumberDetailBadge tone="blue">
                                            {numberDetailsRow.trunkId.name}
                                        </NumberDetailBadge>
                                    ) : (
                                        "-"
                                    )}
                                </NumberDetailItem>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <div className="number-details-overview">
                                <div className="number-details-overview__visual" aria-hidden>
                                    <div className="number-details-overview__orb">
                                        <FiPhone size={34} />
                                    </div>
                                    <span className="number-details-overview__spark number-details-overview__spark--one" />
                                    <span className="number-details-overview__spark number-details-overview__spark--two" />
                                    <span className="number-details-overview__spark number-details-overview__spark--three" />
                                </div>
                                <h5 className="number-details-overview__title">Number Overview</h5>
                                <p className="number-details-overview__subtitle">
                                    View detailed information about this number.
                                </p>
                                <div className="number-details-overview__meta">
                                    <FiClock size={14} aria-hidden />
                                    <span>
                                        {formatNumberCreatedAt(numberDetailsRow)
                                            ? `Added on ${formatNumberCreatedAt(numberDetailsRow)}`
                                            : "Created date unavailable"}
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* Remove Inbound Routing Confirm Modal */}
            <Modal show={showRemoveRoutingModal} onHide={() => !removeRoutingLoading && setShowRemoveRoutingModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Remove Inbound Routing</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to remove inbound routing for the selected {selectedNumbers.length} number(s)?
                </Modal.Body>
                <Modal.Footer className="custom-modal-footer">
                    <Button
                        className="p-button-secondary"
                        onClick={() => setShowRemoveRoutingModal(false)}
                        disabled={removeRoutingLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="p-button-danger"
                        onClick={confirmRemoveInboundRouting}
                        disabled={removeRoutingLoading}
                    >
                        {removeRoutingLoading ? "Removing..." : "Remove"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Modal */}
            <RenderDeleteModal
                show={enableDeleteModal} 
                setShow={setEnableDeleteModal} 
                setConfirmDelete={setConfirmDelete} 
                isMultiDelete={isMultiDelete} 
                clearSelectedData={() => setSelectedNumber([])}
            />

            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

            {/* Assign Individual DID Modal */}
            {showAllocateModal && (
                <Modal show={showAllocateModal} onHide={() => {setShowAllocateModal(false); resetAllocateModalState();}}>
                    <Modal.Header closeButton>
                        <Modal.Title>Allocate DID</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formDid">
                                <Form.Label>Select DID</Form.Label>
                                <Dropdown
                                    value={selectedDID?.value}
                                    options={didOptions}
                                    onChange={(e) => {
                                        const selectedOption = didOptions.find(option => option.value === e.value);
                                        setSelectedDID(selectedOption)
                                    }}
                                    placeholder="Select a DID"
                                    className="form-control p-0" 
                                    style={{height:"45px"}}
                                    appendTo="self"
                                    
                                />
                            </Form.Group>
                            <Form.Group controlId="formStatus">
                                <Form.Label>Select Status</Form.Label>
                                <Dropdown
                                    value={selectedStatus}
                                    options={dropdownOptionStatus}
                                    onChange={(e) => setSelectedStatus(e.value)}
                                    placeholder="Select Status"
                                    className="form-control p-0"style={{ height: "45px" }}
                                    appendTo="self"
                                />
                            </Form.Group>

                            {selectedStatus && ["Reserved", "Blocked"].includes(dropdownOptionStatus.find(option => option.value === selectedStatus)?.label) && (
                               <div className="expiry-date-container">
                                  <Form.Group as={Col} controlId="expiryDate">
                                     <Form.Label>Expiry Date</Form.Label>
                                     <Form.Control
                                        type="date"
                                        value={expiryDate}
                                        onChange={handleExpiryDateChange}
                                        isInvalid={!!expiryDateError}
                                      />
                                   <Form.Control.Feedback type="invalid">
                                        {expiryDateError}
                                   </Form.Control.Feedback>
                                 </Form.Group>
                                </div>
                            )}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="custom-modal-footer">
                        <Button className="p-button-secondary" onClick={() => {setShowAllocateModal(false); resetAllocateModalState();}}>
                            Close
                        </Button>
                        <Button className="p-button-primary" onClick={handleAllocate}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}


                {/* Assign BULK DID Modal */}
                <Modal show={showBulkAssignModal} onHide={() => setShowBulkAssignModal(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title  style={{fontSize: '16px'}}>Bulk Assign DID for {numberType}</Modal.Title>
                  </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Button variant="primary" 
                            onClick={(event) => {
                                const { columns, filename } = getColumnsAndFilenameForAssignDID(numberType);
                                downloadTemplate(event, columns, filename);
                            }}
                            style={{ marginBottom: '15px' }}
                        >
                           Download Template
                        </Button>
                        <Form.Group controlId="formFile">
                            {/* <Form.Label>Upload CSV File</Form.Label> */}
                            <Form.Control type="file" onChange={(e) =>handleFileUpload(e)} accept=".csv" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="custom-modal-footer">
                    <Button variant="p-button-secondary button-sm" onClick={() => {setShowBulkAssignModal(false); setShowAssignDidButton(false)}}>
                      Close
                    </Button>
                    <Button variant="p-button-primary button-sm" onClick={handleBulkAssign}>
                        Upload
                    </Button>
                </Modal.Footer>
                </Modal>

                {/* Bulk Update Model  */}
                <Modal show={bulkUpdateModal} onHide={()=> setBulkUpdateModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Bulk Update</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form>
                            
                                <div className='row'>
                                    <Form.Group className="col-md-12 form-group">
                                        <Form.Label>Select Number Type</Form.Label>
                                        <Form.Select
                                            id="numberType"
                                            value={updateNumberType}
                                            className="p-2"
                                            onChange={(e) =>setUpdateNumberType(e.target.value)}
                                            required
                                        >
                                            <option value={""}>Select Number Type</option>
                                            {NUMBERS_TYPES.map(function(val,idx){
                                            return(
                                                <option key ={idx} value={val.value}>
                                                {val.label}
                                                </option>
                                            )
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div>
                                    {updateNumberType && (
                                        <>
                                            <Button variant="primary" 
                                                onClick={(event) => {
                                                    const { columns, filename, sample_data } = getColumnsAndFilename(updateNumberType);
                                                    downloadTemplate(event, columns, filename, null, sample_data);
                                                }}
                                                style={{
                                                    marginBottom: '15px',
                                                    backgroundColor: '#3a57e8',
                                                    borderColor: '#3a57e8',
                                                    fontSize: '16px',
                                                    borderRadius: '5px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                                                    }}
                                                    >
                                                    Download Template
                                            </Button>
                                            {updateNumberType && (
                                                    <div
                                                      style={{
                                                        background: "#FFF8C6",
                                                        color: "#6B4E16",
                                                        padding: "14px 16px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #FFE08A",
                                                        fontSize: "14px",
                                                        lineHeight: "1.6",
                                                      }}
                                                    >
                                                      <div style={{ fontWeight: 600, marginBottom: "6px" }}>
                                                        ⚠️ Important Information
                                                      </div>
                                            
                                                      <ul style={{ margin: 0, paddingLeft: "18px" }}>
  <li>
    Set <b>Number Routing</b> in the template using <b>incoming</b>, <b>outgoing</b>, or <b>both</b>.
  </li>
  <li>
    Please use the following values to set the respective status in the Status column of the downloaded template:
    <ul>
      <li><strong>1</strong> – Available</li>
      <li><strong>2</strong> – Reserved</li>
      <li><strong>3</strong> – Blocked</li>
      <li><strong>4</strong> – Archived</li>
      <li><strong>6</strong> – Demo</li>
      <li><strong>7</strong> – Live</li>
      <li><strong>8</strong> – Delete</li>
      <li><strong>9</strong> – Pending</li>
      <li><strong>10</strong> – Reject</li>
    </ul>
  </li>
</ul>

                                                    </div>
                                                  )}
                                                  <hr />
                                        </>
                                        )}
                            </div>
                            {updateNumberType && (
                                <Form.Group controlId="formFile">
                                    <Form.Label>Upload </Form.Label>
                                    <Form.Control type="file" onChange={(e) =>handleFileUpload(e)} accept=".csv, .xls, application/vnd.ms-excel" />
                                </Form.Group>
                            )}
                            </Form>
                        </Modal.Body>

                        <Modal.Footer className="custom-modal-footer">
                            <Button variant="p-button-secondary" onClick={() => {setBulkUpdateModal(false); resetAllocateModalState(); setShowAssignDidButton(false);}}>
                            Close
                            </Button>
                            <Button variant="p-button-primary" onClick={() => {handleBulkUpdate(); setBulkUpdateModal(false); resetAllocateModalState(); setShowAssignDidButton(false);}}>
                                Upload
                            </Button>
                        </Modal.Footer>
                    
                </Modal>

                <Modal
                    show={showPlanModal}
                    onHide={() => setShowPlanModal(false)}
                    centered
                    >
                    <Modal.Header closeButton>
                        <Modal.Title>Plan Details - {selectedPlanName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedPlanDetails.length > 0 ? (
                        <div>
                            {selectedPlanDetails.map((plan, index) => (
                            <div key={index} style={{ marginBottom: '10px' }}>
                                <strong>{plan.plan_type}</strong><br />
                                Pulse Duration: {plan.pulse_duration}<br />
                                Pulse Price: {plan.pulse_price}
                            </div>
                            ))}
                        </div>
                        ) : (
                        <div>No plan details available.</div>
                        )}
                    </Modal.Body>
                </Modal>

        </>
    )

}
